<ion-header>
  <ion-toolbar>
    <ion-title>{{address_type == 'Edit'?'Edit Address':'Add Address'}}</ion-title>
    <ion-button slot="end" fill="clear" class="white_color" color="primary-pos-bg" (click)="close()">
      <ion-icon name="close-sharp"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>
<ion-content>
  <!-- <app-cus-add-address [address_type]="address_type" [address_info]="address_info"></app-cus-add-address> -->
  <!-- [address_type]="address_type" [address_info]="address_info" -->
  <ion-grid>
    <form class="address__form" [formGroup]='address_form'>
      <div *ngIf="!db.ismobile">
        <div class="maps-container">
          <div class="d__flex location__input" #location_dropdownn>
            <div class="location__search w-100">
              <input #addresstext class="input" placeholder="Search your location" type="text">
            </div>
            <ion-button fill="clear" class="m-0 location-button-wb ion-text-capitalize" (click)="db.current_locate('')">
              <ion-icon name="locate-outline"></ion-icon>
            </ion-button>
          </div>
          <div>
            <app-maps></app-maps>
          </div>
         <p class="m-0 fnt-12 location__warning" *ngIf="db.available_location">{{db.location_error}}</p>
        </div>

        <div class="input-item">
          <ion-label color="grey" class="input__title fnt-12" position="stacked">Address </ion-label>
          <div lines="none" class="custom-input" [class.focused]="focus.address"> 
            <ion-input name="address" [disabled]="true" [(ngModel)]="db.location_info.address" (ionFocus)="focus.address = true" (ionBlur)="focus.address = false" class="form-input" autofocus="true" autocomplete="false" required="true" formControlName="address" ></ion-input>
          </div>
          <div *ngIf="submitted && !address?.valid"> 
            <p class="error m-0" *ngIf="address.errors.required">address is required</p> 
          </div>
        </div>

        <div class="d__flex separator">
          
          <div class="input-item" >
            <ion-label color="grey" class="input__title fnt-12" position="stacked">House Type </ion-label> 
            <div lines="none" class="custom-input" [class.focused]="focus.house_type">
              <ion-select name="house_type" formControlName="house_type" (ionFocus)="focus.house_type = true" (ionBlur)="focus.house_type = false" class="form-input form-select" interface="popover"  [value]="address_info.house_type">
                <ion-select-option value="Individual">Individual</ion-select-option>
                <ion-select-option value="Apartment">Apartment</ion-select-option>
              </ion-select>
            </div>
            <div *ngIf="submitted && !house_type?.valid"> 
              <p class="error m-0" *ngIf="house_type.errors.required">House Type is required</p> 
            </div>
          </div>

          <div class="input-item" >
            <ion-label color="grey" class="input__title fnt-12" position="stacked"> {{house_type.value =='Individual'?'House No, House Name, Street Name':'Flat No, Apartment / Villa Name'}} </ion-label>
            <div lines="none" class="custom-input" [class.focused]="focus.door_no"> 
              <ion-input name="door_no" (ionFocus)="focus.door_no = true" (ionBlur)="focus.door_no = false" class="form-input" autofocus="true" autocomplete="false" required="true" formControlName="door_no"></ion-input>
            </div>
            <div *ngIf="submitted && !door_no?.valid"> 
              <p class="error m-0" *ngIf="door_no.errors.required"> {{house_type.value =='Individual'?'House No, House Name, Street Name':'Flat No, Apartment / Villa Name'}}   is required</p>  
            </div>
          </div>

        </div>

        <div class="input-item" >
          <ion-label color="grey" class="input__title fnt-12" position="stacked">Landmark</ion-label>
          <div lines="none" class="custom-input" [class.focused]="focus.landmark">
            <ion-input name="landmark" class="form-input" (ionFocus)="focus.landmark = true" (ionBlur)="focus.landmark = false" formControlName="landmark" autocomplete="false" ></ion-input>
          </div>
          <div *ngIf="submitted && !landmark?.valid"> 
            <p class="error m-0" *ngIf="landmark.errors.required">Landmark is required</p> 
          </div>
        </div>


        <!-- <ion-row *ngIf="false">
          <ion-col size="6">
            <ion-item lines="none" class="">
              <ion-label position="stacked">First Name <span class="err">*</span></ion-label>
              <ion-input name="first_name" class="form-input" autofocus="true" autocomplete="false" required="true" formControlName="first_name" [ngClass]="{'is-invalid': submitted && validation.first_name.errors}"></ion-input>
            </ion-item>
            <p *ngIf='submitted && validation.first_name.errors'>Enter First Name</p>
            <ion-item lines="none" class="">
              <ion-label position="stacked">Last Name <span class="err"></span></ion-label>
              <ion-input name="last_name" class="form-input" autofocus="true" autocomplete="false" required="true" formControlName="last_name"></ion-input>
            </ion-item>
            <ion-item lines="none" class="">
              <ion-label position="stacked">Address <span class="err">*</span></ion-label>
              <ion-input name="address" [disabled]="true" [(ngModel)]="db.location_info.address" (ionFocus)="focus.address = true" (ionBlur)="focus.address = false" class="form-input" autofocus="true" autocomplete="false" required="true" formControlName="address" ></ion-input>
              
            </ion-item>
            <p *ngIf='submitted && validation.address.errors'>Enter your address</p>
            
            <ion-item lines="none" class="">
              <ion-label position="stacked">City <span class="err">*</span></ion-label>
              <ion-input name="city" class="form-input" formControlName="city" autocomplete="false" required="true" [ngClass]="{'is-invalid': submitted && validation.first_name.errors}"></ion-input>
            </ion-item>
            <p *ngIf='submitted && validation.city.errors'>Enter your city</p>
          </ion-col>
          <ion-col  size="6">
            <ion-item lines="none" class="">
              <ion-label class="box-label" position="stacked">Country <span class="err">*</span></ion-label>
              <ion-select name="country" formControlName="country" class="ion__select" interface="popover" (ionChange)="value_changed($event)" value="{{address_info.country}}">
                <ion-select-option *ngFor="let c of country_list" value="{{c.name}}">{{c.name}}</ion-select-option>
              </ion-select>
            </ion-item>
            <ion-item lines="none" class="">
              <ion-label class="box-label" position="stacked">State <span class="err">*</span></ion-label>
              <ion-select name="state" formControlName="state" class="ion__select" interface="popover" value="{{address_info.state}}">
                <ion-select-option *ngFor="let c of states_list" value="{{c.name}}">{{c.name}}</ion-select-option>
              </ion-select>
            </ion-item>
            <ion-item lines="none" class="">
              <ion-label position="stacked">Postal Code <span class="err">*</span></ion-label>
              <ion-input name="zipcode" class="form-input" formControlName="zipcode" autocomplete="false" required="true" [ngClass]="{'is-invalid': submitted && validation.zipcode.errors}"></ion-input>
            </ion-item>
            <p *ngIf='submitted && validation.zipcode.errors'>Enter a valid postal code</p>
          </ion-col>
        </ion-row> -->
      </div>
      <div *ngIf="db.ismobile">
       <p class="m-0 fnt-12 location__warning" *ngIf="db.available_location">{{db.location_error}}</p>
        <ion-item lines="none" class="">
          <ion-label position="stacked">First Name <span class="err">*</span></ion-label>
          <ion-input name="address_info.first_name" class="form-input" autofocus="true" autocomplete="false" required="true" formControlName="first_name" [ngClass]="{'is-invalid': submitted && validation.first_name.errors}"></ion-input>
        </ion-item>
        <p *ngIf='submitted && validation.first_name.errors'>Enter First Name</p>
        <ion-item lines="none" class="">
          <ion-label position="stacked">Last Name <span class="err"></span></ion-label>
          <ion-input name="address_info.last_name" class="form-input" autofocus="true" autocomplete="false" required="true" formControlName="last_name"></ion-input>
        </ion-item>
        <ion-item lines="none" class="">
          <ion-label position="stacked">Address <span class="err">*</span></ion-label>
          <ion-input name="address_info.address" class="form-input" autofocus="true" autocomplete="false" required="true" formControlName="address" [ngClass]="{'is-invalid': submitted && validation.address.errors}"></ion-input>
        </ion-item>
        <p *ngIf='submitted && validation.address.errors'>Enter your address</p>
        <!--  <ion-item lines="none" class="">
          <ion-label color="grey" class="input__title" position="stacked">Phone </ion-label>
          <ion-input (ionChange)="format_phone($event)" name="phone" class="form-input" type="text" formControlName="phone" (ionFocus)="focus.phone = true" (ionBlur)="focus.phone = false" autocomplete="false" required="true"></ion-input>
        </ion-item>
            
            <p class="m-0 error" *ngIf="submitted && !phone.valid && phone.errors.required">Enter Your Mobile Number</p>
            <p class="m-0 error" *ngIf="submitted && !phone.valid && phone.errors.pattern">Enter a valid Mobile Number</p> -->
        <ion-item lines="none" class="">
          <ion-label position="stacked">City <span class="err">*</span></ion-label>
          <ion-input name="address_info.city" class="form-input" formControlName="city" autocomplete="false" required="true" [ngClass]="{'is-invalid': submitted && validation.city.errors}"></ion-input>
        </ion-item>
        <p *ngIf='submitted && validation.city.errors'>Enter your city</p>
        <ion-item lines="none" class="">
          <ion-label class="box-label" position="stacked">Country <span class="err">*</span></ion-label>
          <ion-select name="country" formControlName="country" class="ion__select" interface="popover" (ionChange)="value_changed($event)" value="{{address_info.country}}">
            <ion-select-option *ngFor="let c of country_list" value="{{c.name}}">{{c.name}}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item lines="none" class="">
          <ion-label class="box-label" position="stacked">State <span class="err">*</span></ion-label>
          <ion-select name="state" formControlName="state" class="ion__select" interface="popover" value="{{address_info.state}}">
            <ion-select-option *ngFor="let c of states_list" value="{{c.name}}">{{c.name}}</ion-select-option>
          </ion-select>
        </ion-item>
        <p *ngIf='submitted && validation.state.errors'>State is required</p>
        <ion-item lines="none" class="">
          <ion-label position="stacked">Postal Code <span class="err">*</span></ion-label>
          <ion-input name="address_info.zipcode" type="text" class="form-input" formControlName="zipcode" autocomplete="false" required="true" [ngClass]="{'is-invalid': submitted && validation.zipcode.errors}"></ion-input>
        </ion-item>
        <!-- <p *ngIf='submitted && validation.zipcode.errors'>postal code is required</p> -->
        <p *ngIf='submitted && validation.zipcode.errors'>Enter a valid postal code</p>
      </div>
    </form>
  </ion-grid>
</ion-content>
<ion-footer>
  <ion-toolbar [formGroup]='address_form' class="ion__toolbar">
    <div class="ion__button">
      <ion-button [disabled]="db.available_location" fill="clear" expand="full" (click)="address_type == 'Edit'? edit_address() : db.ismobile ? insert_address1() : insert_address()">{{address_type == 'Edit'?'Update':'Save'}}</ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
